<template>

  <KedvezmenyekBase>

    <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

      <BnFormField v-if="csaladiVisible()" :attributes="csaladi"/>

      <BnFormField v-if="cascoVisible()" :attributes="casco"/>

      <BnFormField v-if="egyhazVisible()" :attributes="egyhaz"/>

      <BnFormField v-if="audiVisible()" :attributes="audi"/>

      <BnFormField v-if="porscheVisible()" :attributes="porsche"/>

      <BnFormField v-if="raiffeisenVisible()" :attributes="raiffeisen"/>

      <BnFormField v-if="kmallaIsmertVisible()" :attributes="kmallas"/>

      <BnFormField v-if="lakasEgyuttVisible()" :attributes="lakas_egyutt"/>

      <BnFormField v-if="balesetEgyuttVisible()" :attributes="baleset_egyutt"/>

      <BnFormField v-if="cherriskVisible()" :attributes="cherrisk"/>

      <BnFormField v-if="raiffeisenBankszamlaVisible()" :attributes="raiffeisen_bankszamla"/>

      <BnFormField v-if="ujRaiffeisenBankszamlaVisible()" :attributes="uj_raiffeisen_bankszamla"/>

    </v-layout>

  </KedvezmenyekBase>

</template>

<script>
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import KedvezmenyekBase from '../KedvezmenyBase.vue';
import TariffAnnouncementUtils from '../../../../../../../utils/TariffAnnouncementUtils';

export default {
  name: 'KedvezmenyekB6',
  components: {BnFormField, KedvezmenyekBase},
  mixins: [Kedvezmeny],
  mounted() {
    if (this.lakasBiztosito === 10) { // uniqa
      this.$store.commit('setProp', {
        path: 'kedvezmenyekbiztosito.6.lakas_egyutt',
        value: true,
      });
    }
  },
  methods: {
    egyhazVisible() {
      return this.isSZGK() && this.isTermeszetesSzemely();
    },
    porscheVisible() {
      return this.isSZGK() && this.isTermeszetesSzemely();
    },
    raiffeisenVisible() {
      return this.isSZGK() && this.isTermeszetesSzemely();
    },
    raiffeisenBankszamlaVisible() {
      return TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2026, 'kgfb', this.$store)
          && TariffAnnouncementUtils.isKockakezdetAfterOrEqualMonth('kgfb', this.$store, 4);
    },
    ujRaiffeisenBankszamlaVisible() {
      return (this.isSZGK || this.isTeherKisebb3500kg()) && this.isTermeszetesSzemely() && this.getValue('tarifaData.eugyintezes') === true;
    },
    cascoVisible() {
      return this.isSZGK() || this.isTeherKisebb3500kg();
    },
    audiVisible() {
      return this.isSZGK() && this.isTermeszetesSzemely();
    },
    csaladiVisible() {
      return this.isSZGK() && this.isTermeszetesSzemely();
    },
    kmallaIsmertVisible() {
      return this.isSZGK() && TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2023, 'kgfb', this.$store);
    },
    lakasEgyuttVisible() {
      return this.isSZGK() && TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2024, 'kgfb', this.$store);
    },
    balesetEgyuttVisible() {
      return this.isSZGK() && TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2024, 'kgfb', this.$store);
    },
    cherriskVisible() {
      return this.getValue('tarifaData.eugyintezes') === true
          && this.isSZGK() && TariffAnnouncementUtils.isKockakezdetLesser(2025, 'kgfb', this.$store);
    },
  },
  computed: {
    lakasBiztosito() {
      return this.$store.getters.tarifaData.lbiztosito;
    },
    kedvezmenyek() {
      return this.$store.getters.kedvezmenyekbiztosito['6'];
    },
    casco() {
      return {
        type: 'checkbox',
        label: 'UNIQA casco kedvezmény',
        visible: true,
        editable: !this.disabled
            && !this.egyuttkotve
            && !this.kedvezmenyek.lakas_egyutt
            && !this.kedvezmenyek.baleset_egyutt,
        rules: [],
        mezo: 'uniqua_casco',
        path: 'kedvezmenyekbiztosito.6.casco',
        help: true,
        change: this.shouldRecalc,
      };
    },
    lakas_egyutt() {
      return {
        type: 'checkbox',
        label: 'Lakás együttkötési kedvezmény',
        visible: true,
        editable: !this.disabled
            && !this.egyuttkotve
            && this.lakasBiztosito !== 10 // uniqa
            && !this.kedvezmenyek.casco
            && !this.kedvezmenyek.baleset_egyutt,
        path: 'kedvezmenyekbiztosito.6.lakas_egyutt',
        mezo: 'lakas_egyutt',
        help: true,
        rules: [],
        change: this.shouldRecalc,
      };
    },
    baleset_egyutt() {
      return {
        type: 'checkbox',
        label: 'Baleset együttkötési kedvezmény',
        visible: true,
        editable: !this.disabled
            && !this.egyuttkotve
            && !this.kedvezmenyek.casco
            && !this.kedvezmenyek.lakas_egyutt,
        path: 'kedvezmenyekbiztosito.6.baleset_egyutt',
        mezo: 'baleset_egyutt',
        help: true,
        rules: [],
        change: this.shouldRecalc,
      };
    },
  },
  data() {
    return {
      egyhaz: {
        type: 'checkbox',
        label: 'Magyarországi egyház alkalmazottja',
        visible: true,
        editable: !this.disabled,
        rules: [],
        mezo: 'uniqua_egyhaz',
        path: 'kedvezmenyekbiztosito.6.egyhaz',
        help: true,
        change: this.shouldRecalc,
      },
      porsche: {
        type: 'checkbox',
        label: 'Porsche cégcsoport alkalmazottja',
        visible: true,
        editable: !this.disabled,
        rules: [],
        mezo: 'uniqua_porsche',
        path: 'kedvezmenyekbiztosito.6.porsche',
        help: true,
        change: this.shouldRecalc,
      },
      raiffeisen: {
        type: 'checkbox',
        label: 'Raiffeisen cégcsoport alkalmazottja',
        visible: true,
        editable: !this.disabled,
        rules: [],
        mezo: 'uniqua_raiffeisen',
        path: 'kedvezmenyekbiztosito.6.raiffeisen',
        help: true,
        change: this.shouldRecalc,
      },
      raiffeisen_bankszamla: {
        type: 'checkbox',
        label: 'Rendelkezik Raiffeisen bankszámlával',
        visible: true,
        editable: !this.disabled,
        rules: [],
        mezo: 'uniqua_raiffeisen',
        path: 'kedvezmenyekbiztosito.6.raiffeisen_bankszamla',
        help: true,
        change: this.shouldRecalc,
      },
      uj_raiffeisen_bankszamla: {
        type: 'checkbox',
        label: 'Új Raiffeisen bankszámla',
        visible: true,
        editable: !this.disabled,
        rules: [],
        mezo: 'uniqua_uj_raiffeisen',
        path: 'kedvezmenyekbiztosito.6.uj_raiffeisen_bankszamla',
        help: true,
        change: this.shouldRecalc,
      },
      csaladi: {
        type: 'checkbox',
        label: 'Családi kedvezmény',
        visible: true,
        editable: !this.disabled,
        rules: [],
        mezo: 'uniqua_csaladi',
        path: 'kedvezmenyekbiztosito.6.csaladi',
        help: true,
        change: this.shouldRecalc,
      },
      audi: {
        type: 'checkbox',
        label: 'Magyar autóklub tag kedvezmény',
        visible: true,
        editable: !this.disabled,
        rules: [],
        mezo: 'uniqua_audi',
        path: 'kedvezmenyekbiztosito.6.audi',
        help: true,
        change: this.shouldRecalc,
      },
      kmallas: {
        type: 'checkbox',
        label: 'Km óra állása ismert',
        visible: true,
        editable: !this.disabled,
        path: 'kedvezmenyekbiztosito.6.kmallas',
        mezo: 'uniqa_kmallas',
        help: true,
        rules: [],
        change: this.shouldRecalc,
      },
      cherrisk: {
        type: 'checkbox',
        label: 'Rendelkezik Cherrisk GO App regisztrációval',
        visible: true,
        editable: !this.disabled,
        path: 'kedvezmenyekbiztosito.6.cherrisk',
        mezo: 'cherrisk',
        help: true,
        rules: [],
        change: this.shouldRecalc,
      },
    };
  },
};
</script>
